import ImageIcon from "@redotech/redo-icons/image-01_filled.svg";
import { memo, useState } from "react";
import { Flex } from "./flex";
import * as css from "./image-display-with-placeholder.module.css";

interface ImageDisplayWithPlaceholderProps {
  src: string;
  alt: string;
  size?: "xxs" | "xs" | "sm" | "md" | "lg" | "xl" | "2xl";
  className?: string;
}

/**
 * Component that handles image loading errors
 * and shows a placeholder icon when the original image can't be loaded.
 */
export const ImageDisplayWithPlaceholder = memo(
  function ImageDisplayWithPlaceholder({
    src,
    alt,
    size = "md",
    className,
  }: ImageDisplayWithPlaceholderProps) {
    const [imageError, setImageError] = useState(false);

    const handleImageError = () => {
      setImageError(true);
    };

    // When image fails to load, display the placeholder icon
    if (imageError) {
      return (
        <Flex
          align="center"
          borderRadius="sm"
          className={`${css.placeholderContainer} ${css[size]} ${className || ""}`}
          justify="center"
        >
          <ImageIcon className={css.placeholderIcon} />
        </Flex>
      );
    }

    // Otherwise display the actual image
    return (
      <img
        alt={alt}
        className={`${css.productImage} ${css[size]} ${className || ""}`}
        data-web="ImageDisplayWithPlaceholder"
        onError={handleImageError}
        src={src}
      />
    );
  },
);
